import { DealersService } from "~/entity/Dealers/api/service";
import { useDealersForSelect } from "~/entity/Dealers/hooks/useDealersForSelect";

export const useDealers = () => {
  const dealersMy = DealersService.GET.getMyDealer;

  return {
    dealersMy,
    useDealersForSelect,
  };
};
